import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useCallback, useState, useLayoutEffect } from 'react';
import PopperJS from 'popper.js';
import { Portal } from '../portal/Portal';
import { useDefaultRef } from '../utils/useDefaultRef';
import { Box } from '../grid/Grid';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
var defaultPopperOptions = {};

function autoSizing(data) {
  data.styles.width = data.offsets.reference.width;
  return data;
}

var autoSizeConfig = {
  enabled: true,
  fn: autoSizing,
  order: 840
};
var placementMap = {
  bottom: 'bottom',
  bottomLeft: 'bottom-start',
  bottomRight: 'bottom-end',
  top: 'top',
  topLeft: 'top-start',
  topRight: 'top-end',
  right: 'right',
  left: 'left'
};
var TooltipWrap = styled(Box)(_templateObject(), themeGet('zIndex.tooltip'));
export var Popper =
/*#__PURE__*/
React.forwardRef(function Popper(props, ref) {
  var referRef = props.referRef,
      children = props.children,
      container = props.container,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disabledPopper = props.disabledPopper,
      disabledPopper = _props$disabledPopper === void 0 ? false : _props$disabledPopper,
      _props$dynamicWidth = props.dynamicWidth,
      dynamicWidth = _props$dynamicWidth === void 0 ? false : _props$dynamicWidth,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      other = _objectWithoutProperties(props, ["referRef", "children", "container", "keepMounted", "disablePortal", "disabledPopper", "dynamicWidth", "transition", "open", "placement", "popperOptions", "popperRef"]);

  var _useDefaultRef = useDefaultRef(ref),
      _useDefaultRef2 = _slicedToArray(_useDefaultRef, 2),
      tooltipRef = _useDefaultRef2[0],
      setTooltipRef = _useDefaultRef2[1];

  var _useDefaultRef3 = useDefaultRef(popperRefProp),
      _useDefaultRef4 = _slicedToArray(_useDefaultRef3, 2),
      popperRef = _useDefaultRef4[0],
      setPopperRef = _useDefaultRef4[1];

  var _useState = useState(placementMap[initialPlacement] || placementMap.bottom),
      _useState2 = _slicedToArray(_useState, 2),
      placement = _useState2[0],
      setPlacement = _useState2[1];

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      exited = _React$useState2[0],
      setExited = _React$useState2[1];

  var openPopper = useCallback(function () {
    if (disabledPopper || !tooltipRef.current || !referRef.current) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      setPopperRef(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    var popper = new PopperJS(referRef.current, tooltipRef.current, _objectSpread({
      placement: placementMap[initialPlacement]
    }, popperOptions, {
      modifiers: _objectSpread({}, popperOptions.modifiers, {}, dynamicWidth ? {
        autoSizing: autoSizeConfig
      } : {}),
      onCreate: function onCreate() {
        handlePopperUpdate.apply(void 0, arguments);
        (popperOptions.onCreate || function () {}).apply(void 0, arguments);
      },
      onUpdate: function onUpdate() {
        handlePopperUpdate.apply(void 0, arguments);
        (popperOptions.onUpdate || function () {}).apply(void 0, arguments);
      }
    }));
    setPopperRef(popper);
  }, [disabledPopper, tooltipRef, referRef, popperRef, initialPlacement, popperOptions, dynamicWidth, setPopperRef]);
  useEffect(function () {
    openPopper();
  }, [openPopper]);

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    setPopperRef(null);
  };

  useEffect(function () {
    if (!open && !transition && !keepMounted) {
      // Otherwise handleExited will call this.
      handleClose();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [open, transition, keepMounted]);
  useEffect(function () {
    return function () {
      handleClose();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useLayoutEffect(function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleRef = useCallback(function (node) {
    setTooltipRef(node);
    openPopper();
  }, [setTooltipRef, openPopper]);

  var handleEnter = function handleEnter() {
    if (exited) {
      setExited(false);
    }
  };

  var handleExited = function handleExited() {
    if (!exited) {
      setExited(true);
      handleClose();
    }
  };

  var childProps = {
    placement: placement,
    open: open
  };

  if (transition) {
    childProps = _objectSpread({}, childProps, {
      onEnter: handleEnter,
      onExit: handleExited
    });
  }

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  return (
    /*#__PURE__*/
    React.createElement(Portal, {
      disablePortal: disablePortal,
      container: container
    },
    /*#__PURE__*/
    React.createElement(TooltipWrap, _extends({
      ref: handleRef,
      role: "tooltip"
    }, other, {
      style: {
        // fix Popper.js display issue
        top: 0,
        left: 0
      }
    }), typeof children === 'function' ? children(childProps) : children))
  );
});
export default Popper;